import axios from "axios"
import baseUrl from "./base"

const authApi = {
  getProfile: async (token) => {
    return await axios.get(`${baseUrl}/api/profile`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getUser: async (token) => {
    return await axios.get(`${baseUrl}/api/user`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateProfile: async (token, data) => {
    return await axios.post(`${baseUrl}/api/updateProfile`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFotoProfil: async (token, data) => {
    return await axios.post(`${baseUrl}/api/updateFotoProfil`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFirebaseTokenWeb: async (token, data) => {
    return await axios.post(`${baseUrl}/api/storeFirebaseTokenWeb`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validateOtp: async (token, data) => {
    return await axios.post(`${baseUrl}/api/validateOtp`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },

  fetchUserTtd: async (token) => {
    return await axios.get(`${baseUrl}/api/ttdPenduduk/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeUserTtd: async (token, data) => {
    return await axios.post(`${baseUrl}/api/ttdPenduduk/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateUserTtd: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/ttdPenduduk/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showUmkmUser: async (token) => {
    return await axios.get(`${baseUrl}/api/umkm/get-by-user`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteUserTtd: async (token, id) => {
    return await axios.post(`${baseUrl}/api/ttdPenduduk/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
}

export default authApi